import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['filtersForm', 'filtersFormSubmit', 'endDateWrapper']

  connect() {
    window.addEventListener('focus', () => {
      if (this.filtersFormSubmitTarget) {
        this.filtersFormSubmitTarget.removeAttribute('disabled')
      }
    })
  }

  toggleShowEndDate(event) {
    if(event.target.checked) {
      this.endDateWrapperTarget.classList.add('d-none')
    } else {
      this.endDateWrapperTarget.classList.remove('d-none')
    }
  }

  clearFilters(event) {
    event.preventDefault()

    this.filtersFormTarget.reset()

    // required because form.reset() does not reset tomselects
    const selects = this.filtersFormTarget.getElementsByClassName('tomselected')
    for (let ts of selects) {
      ts.tomselect.clear()
    }
  }
}
